export const mapCenter = function(v, callback) {
	//console.log("百度定位" + v)
	this.oMap.centerAndZoom(v, 18)
	let that = this;
	setTimeout(function() {
		let {
			lat,
			lng
		} = that.oMap.getCenter();
		let point = new BMap.Point(lng, lat);
		callback({
			lng,
			lat,
			point
		})
	}, 1000);
}
export const mapInit = function(callback) {
	this.oMap = new BMap.Map("region-baidu-map");
	var mapStyle ={
        features: ["road","building","water","land"],//隐藏地图上的"poi",
        style : "midnight",
    };
    this.oMap.setMapStyle(mapStyle);
	let that = this;
	this.oMap.addEventListener("click", function(e) {
		let {
			lng,
			lat
		} = e.point;
		setTimeout(function() {
			let infoWindow = that.oMap.getInfoWindow();
			if (!infoWindow) {
				geocoder.call(that,{
					lng,
					lat
				});
			} else {
				if (infoWindow.getContent().className == "geocoder") {
					infoWindow.close();
					geocoder.call(that,{
						lng,
						lat
					});
					return;
				} //if
				let section = document.createElement('section');
				section.innerHTML = infoWindow.getTitle();
				let name = section.querySelectorAll("a")[0].innerText
				let address = infoWindow.getContent().querySelectorAll("p")[0].innerText;
				callback({
					lng,
					lat,
					name,
					address
				})
				//console.log('百度地图可点击', "名称：" + name, "地址：" + address);
			} //else
		}, 1000)
	}, false);
}

export const geocoder = function({
	lng,
	lat
}) {
	let point = new BMap.Point(lng, lat);
	let getData = new BMap.Geocoder();
	let that = this;
	getData.getLocation(point, function(rs) {
		let address = rs.address;
		let name = rs.surroundingPois[0] && rs.surroundingPois[0].title || '';
		//console.log('自身点击', "名称：" + name, "地址：" + address);
		if (address) {
			diyInfoWindow.call(that,name + '附近', address, point);
		}
	})
};

export const diyInfoWindow = function(name, address, point) {
	let div = document.createElement("div");
	let infoWindow = new BMap.InfoWindow(div, {
		title: `<div style='height:26px;' id='detailDiv'><a  filter='detailInfo'  target='_blank' style='font-size:14px;color:#4d4d4d;font-weight:bold;text-decoration:none;'>${name}</a><a  filter='detailLink' href='#' target='_blank'></a></div>`,
	}); //弹出窗口
	let that = this;
	div.className = "geocoder";
	div.style = "font-size: 12px; padding: 5px 0px; overflow: hidden;";
	div.innerHTML = `<p style="padding: 0px; margin: 0px; line-height: 18px; font-size: 12px; color: rgb(77, 77, 77);">地址：${address}</p>`;
	that.$set(that.formLabelAlign, "name", name);
	that.$set(that.formLabelAlign, "address", address);
	that.$set(that.formLabelAlign, "longitude", point.lng > 0 ? point.lng : 0);
    that.$set(that.formLabelAlign, "latitude", point.lat > 0 ? point.lat : 0);
	//console.log(point.lng)
	// that.$set(that.formLabelAlign, "longitude", lng > 0 ? lng : 0);
    // that.$set(that.formLabelAlign, "latitude", lat > 0 ? lat : 0);
	that.oMap.openInfoWindow(infoWindow, point);
};


// WEBPACK FOOTER //
// ./src/components/dynamicRoute2/systemConfiguration/first/system/region copy/map.js